module.exports = __webpack_public_path__ + "static/img/a102.12de220d.png";